import React from "react";

const dotStyle = (delay: number): React.CSSProperties => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  animation: `bounce-dot 1.2s ${delay}s ease-in-out infinite`
});

export function BouncingDotsLoader(): React.ReactNode {
  return (
    <>
      <style>{`
        @keyframes bounce-dot {
          0%, 100% {
            transform: translateY(0);
            background-color: var(--color-orange-100);
          }
          50% {
            transform: translateY(-8px);
            background-color: var(--color-orange-300);
          }
        }
      `}</style>
      <div className="flex items-center justify-center gap-1.5">
        <div style={dotStyle(0)} />
        <div style={dotStyle(0.15)} />
        <div style={dotStyle(0.3)} />
      </div>
    </>
  );
}
